
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"1382","height":"1024"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M156.935 0C70.364 0 0 70.144 0 156.444v711.111c0 86.3 70.364 156.444 156.935 156.444H1212.68c86.569 0 156.933-70.144 156.933-156.444V156.444C1369.613 70.144 1299.249 0 1212.68 0H156.935zm684.806 796.444c-23.626 0-42.801-19.116-42.801-42.668s19.174-42.665 42.801-42.665h313.871c23.626 0 42.801 19.113 42.801 42.665s-19.174 42.668-42.801 42.668H841.741zm0-227.556c-23.626 0-42.801-19.113-42.801-42.665s19.174-42.668 42.801-42.668h313.871c23.626 0 42.801 19.116 42.801 42.668s-19.174 42.665-42.801 42.665H841.741zm0-227.556c-23.626 0-42.801-19.113-42.801-42.665s19.174-42.668 42.801-42.668h313.871c23.626 0 42.801 19.116 42.801 42.668s-19.174 42.665-42.801 42.665H841.741zm-305.477 47.591c0 7.859 6.372 14.231 14.231 14.231h128.643c7.859 0 14.231 6.372 14.231 14.231v196.613c0 7.859-6.372 14.231-14.231 14.231H550.495c-7.859 0-14.231 6.372-14.231 14.231v128.643c0 7.859-6.372 14.231-14.231 14.231H325.42c-7.859 0-14.231-6.372-14.231-14.231V642.46c0-7.859-6.372-14.231-14.231-14.231H168.315c-7.86 0-14.232-6.372-14.232-14.231V417.385c0-7.859 6.372-14.231 14.232-14.231h128.643c7.859 0 14.231-6.372 14.231-14.231V260.28c0-7.86 6.372-14.232 14.231-14.232h196.613c7.859 0 14.231 6.372 14.231 14.232v128.643z"}})])
          )
        }
      }
    